import Vue from 'vue'
import Router from 'vue-router'
const firebase = require('firebase/app')
import store from '../store'

import tabs from './tabs.js'
Vue.use(Router)

var router=  new Router({
    //mode: 'history',
    routes: tabs
})

router.beforeEach((to, from, next) => {
    let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
    let requiresSecretaria = to.matched.some(record => record.meta.requiresSecretaria)

        /*
        if (requiresSecretaria) {
            store.dispatch('group', 'secretaria').then(isFromGroup => {
                console.log(isFromGroup)
                if (isFromGroup && to.name === 'login') next({name: 'secretaria'})
                else if (isFromGroup) next()
                else next({name: 'home'})
            })
        } 
        */
        if (requiresSecretaria) {
            //if(store.getters.isSecretaria == false && store.getters.isScouter == false){
            if(store.getters.isScouter == false){
                console.log('Paso')
                next({name: 'home'})
            } else{
                next()
            }
        }else if (requiresAuth) {
            store.dispatch('auth').then(user => {
                if (user && to.name === 'login') next({name: 'home'})
                else if (user || to.name === 'login') next()
                else next({name: 'login'})
            })
        } else {
            next()
            console.log('FIn')
        }
})

export default router
